import React, { useRef, useState, useEffect, useMemo } from "react";
import { Tooltip } from "Components";

const DEFAULT_USER_NAME_STYLES = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  display: 'inline-block',
  maxWidth: '100%',
};

const DEFAULT_TOOLTIP_POPPER_PROPS = {
  modifiers: [
    {
      name: 'offset',
      options: {
        offset: [0, 0],
      },
    },
  ],
};

const TruncatedText = ({
  text,
  tooltipPlacement = "bottom",
  tooltipPopperProps = DEFAULT_TOOLTIP_POPPER_PROPS,
  tooltipComponentsProps,
  textStyle = DEFAULT_USER_NAME_STYLES,
  component: Component = "span",
  ...restProps
}) => {
  const textRef = useRef(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const element = textRef.current;
    if (element) {
      const truncated = element.scrollWidth > element.clientWidth;
      setIsTruncated(truncated);
    }
  }, [text]);

  const textElement = useMemo(() => (
    <Component ref={textRef} style={textStyle} {...restProps}>
      {text}
    </Component>
  ), [text, textStyle, Component, restProps]);

  if (!text) return null;

  if (isTruncated) {
    return (
      <Tooltip 
        title={text} 
        placement={tooltipPlacement}
        PopperProps={tooltipPopperProps}
        componentsProps={tooltipComponentsProps}
      >
        {textElement}
      </Tooltip>
    );
  }

  return textElement;
};

export default TruncatedText;
